// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalSearch_container__Nar6z","searchIcon":"GlobalSearch_searchIcon__3BTOs","crossIcon":"GlobalSearch_crossIcon__2OksP"};